import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    message: String,
    url: String
  }

  connect() {
    this.tooltip = null;
    this._hideTooltipBound = this.hideTooltip.bind(this);
    this.element.style.cursor = 'pointer';
  }

  disconnect() {
    this.removeTooltip();
  }

  showTooltip() {
    if (this.tooltip) return;

    // Create tooltip container
    this.tooltip = document.createElement('div');
    this.tooltip.className = 'fixed z-[9999] text-sm text-gray-900 bg-white rounded shadow-lg px-4 py-3';
    this.tooltip.style.maxWidth = '320px';
    this.tooltip.style.whiteSpace = 'normal';
    this.tooltip.style.pointerEvents = 'auto';
    this.tooltip.style.boxShadow = '0 4px 16px rgba(0,0,0,0.12)';
    this.tooltip.style.border = '1px solid #e5e7eb';
    this.tooltip.style.position = 'fixed';

    // Add arrow (left side, vertically centered)
    const arrow = document.createElement('div');
    arrow.style.position = 'absolute';
    arrow.style.left = '-8px';
    arrow.style.top = '50%';
    arrow.style.transform = 'translateY(-50%)';
    arrow.style.width = '8px';
    arrow.style.height = '16px';
    arrow.innerHTML = `<svg width="8" height="16"><polygon points="8,0 0,8 8,16" style="fill:white;stroke:#e5e7eb;stroke-width:1"/></svg>`;
    this.tooltip.appendChild(arrow);

    // Add message
    const message = document.createElement('div');
    message.innerHTML = this.hasMessageValue
      ? this.messageValue
      : 'This feature is unavailable on your plan. Please submit an <a href="#" style="color:#e67e22;text-decoration:underline;">Access Request</a>.';
    this.tooltip.appendChild(message);

    // Add mouse events to tooltip for sticky hover
    this.tooltip.addEventListener('mouseenter', () => {
      clearTimeout(this._hideTimeout);
    });
    this.tooltip.addEventListener('mouseleave', this._hideTooltipBound);

    document.body.appendChild(this.tooltip);
    this.positionTooltip();
  }

  hideTooltip() {
    // Use a timeout to allow moving between icon and tooltip
    this._hideTimeout = setTimeout(() => {
      this.removeTooltip();
    }, 80);
  }

  removeTooltip() {
    if (this.tooltip && this.tooltip.parentNode) {
      this.tooltip.removeEventListener('mouseleave', this._hideTooltipBound);
      this.tooltip.parentNode.removeChild(this.tooltip);
      this.tooltip = null;
    }
  }

  positionTooltip() {
    if (!this.tooltip) return;
    const rect = this.element.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();

    // Find the main content area
    const mainContent = document.getElementById('main-content');
    let containerRect = { left: 0, right: window.innerWidth, top: 0, bottom: window.innerHeight };
    if (mainContent) {
      containerRect = mainContent.getBoundingClientRect();
    }

    // Position to the right of the icon, vertically centered
    let top = rect.top + (rect.height / 2) - (tooltipRect.height / 2);
    let left = rect.right + 8; // 8px gap

    // Clamp top/bottom to stay within the main content area
    top = Math.max(top, containerRect.top + 4);
    top = Math.min(top, containerRect.bottom - tooltipRect.height - 4);

    // Clamp right to stay within the main content area
    left = Math.min(left, containerRect.right - tooltipRect.width - 4);

    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.left = `${left}px`;
    this.tooltip.style.position = 'fixed';

    // Position the arrow at the left center
    const arrow = this.tooltip.querySelector('div');
    if (arrow) {
      arrow.style.left = '-8px';
      arrow.style.top = '50%';
      arrow.style.bottom = '';
      arrow.style.transform = 'translateY(-50%)';
    }
  }

  navigate() {
    if (this.hasUrlValue) {
      window.location.href = this.urlValue;
    }
  }
}
